document.addEventListener('DOMContentLoaded', function () {
  var widget = document.getElementById('panda-tb-widget');
  if (!widget) return;
  var threshold = parseInt(widget.dataset.scrollThreshold, 10) || 300;

  var hasStartedPeeking = false;
  var peekCount = 0;
  var MAX_PEEKS = 3;
  var FIRST_DELAY_MS = 1800;
  var PEEK_DURATION_MS = 4200;
  var GAP_BETWEEN_PEEKS_MS = 14000;

  window.addEventListener(
    'scroll',
    function () {
      var isVisible = window.scrollY > threshold;
      widget.classList.toggle('panda-is-visible', isVisible);
      if (isVisible && !hasStartedPeeking) {
        hasStartedPeeking = true;
        setTimeout(schedulePeek, FIRST_DELAY_MS);
      }
    },
    { passive: true }
  );

  // Só o ícone de mira não deixa claro pra que serve o botão — o rótulo
  // "espia" sozinho algumas vezes (sem precisar de hover/toque), e depois
  // some, deixando de aparecer/passar o mouse como jeito de rever o texto.
  function schedulePeek() {
    if (peekCount >= MAX_PEEKS) return;
    widget.classList.add('panda-tb-peek');
    setTimeout(function () {
      widget.classList.remove('panda-tb-peek');
      peekCount++;
      setTimeout(schedulePeek, GAP_BETWEEN_PEEKS_MS);
    }, PEEK_DURATION_MS);
  }

  // O clique em si é tratado globalmente em panda-tamanho-popup.js (delegação
  // em [data-open-tamanho-popup]), reaproveitado também pelo link da página
  // de produto — este arquivo cuida só da visibilidade por scroll e do peek.
});
